var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cn from 'classnames';
import styled, { css } from 'styled-components';
import Addon from './components/Addon';
import { superBoxStyle, isElement, } from '@vital-ui/react-utils';
var Root = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  ", ";\n"], ["\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  ", ";\n"])), superBoxStyle);
var noSpacetyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  > * {\n    width: calc(100% + 2px);\n  }\n\n  &:not(:first-child) > * {\n    margin-left: -1px;\n    margin-right: 0;\n  }\n\n  &:last-child {\n    * {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n\n  &:first-child {\n    * {\n      border-right: 0;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n  }\n\n  &:not(:first-child):not(:last-child) {\n    * {\n      border-radius: 0;\n    }\n  }\n"], ["\n  > * {\n    width: calc(100% + 2px);\n  }\n\n  &:not(:first-child) > * {\n    margin-left: -1px;\n    margin-right: 0;\n  }\n\n  &:last-child {\n    * {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n\n  &:first-child {\n    * {\n      border-right: 0;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n  }\n\n  &:not(:first-child):not(:last-child) {\n    * {\n      border-radius: 0;\n    }\n  }\n"])));
var LabelCell = styled('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: table-cell;\n  vertical-align: top;\n\n  ", ";\n\n  ", ";\n"], ["\n  display: table-cell;\n  vertical-align: top;\n\n  ",
    ";\n\n  ",
    ";\n"])), function (_a) {
    var addon = _a.addon;
    return addon && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      width: 1%;\n      white-space: nowrap;\n    "], ["\n      width: 1%;\n      white-space: nowrap;\n    "])));
}, function (_a) {
    var paddingBetween = _a.paddingBetween;
    return paddingBetween
        ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          :not(:last-child) {\n            padding-right: ", "px;\n          }\n        "], ["\n          :not(:last-child) {\n            padding-right: ", "px;\n          }\n        "])), paddingBetween) : noSpacetyle;
});
/**
 * @render react
 * @name MultipleInput
 * @desc Group of multiple inputs
 * @example
 * <MultipleInput>
 *  <Addon>addon</Addon>
 *  ...
 * </MultipleInput>
 */
var MultipleInput = /** @class */ (function (_super) {
    __extends(MultipleInput, _super);
    function MultipleInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultipleInput.prototype.render = function () {
        var _a = this.props, style = _a.style, className = _a.className, children = _a.children, paddingBetween = _a.paddingBetween, props = __rest(_a, ["style", "className", "children", "paddingBetween"]);
        return (React.createElement(Root, __assign({ style: style, className: cn('vital__multipleInput', className) }, props), children.map(function (child, i) { return (React.createElement(LabelCell, { paddingBetween: paddingBetween, addon: (child && isElement(child) && child.type) === Addon, key: "addon-" + i }, child)); })));
    };
    return MultipleInput;
}(React.Component));
export { MultipleInput };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=MultipleInput.js.map